import { useContext } from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import React from 'react'
import { useSetIsAuto } from 'src/hooks/users/use-set-default-theme.hook'
import { ThemeSwitchContext } from 'src/providers/theme-provider'
import LightModeIcon from '@mui/icons-material/LightMode'
import DarkModeIcon from '@mui/icons-material/DarkMode'

export enum ETheme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
  AUTO = 'AUTO',
}

interface IMultipleSwitchProps {
  size?: 'small' | 'medium' | 'large'
}

const MultipleSwitch = ({ size }: IMultipleSwitchProps) => {
  const { setIsDark, auto_theme, isDark } = useContext(ThemeSwitchContext)
  const { mutate: setIsAuto, isLoading } = useSetIsAuto()

  const [alignment, setAlignment] = React.useState<ETheme>(
    auto_theme ? ETheme.AUTO : isDark ? ETheme.DARK : ETheme.LIGHT,
  )

  const setDark = (e: boolean) => {
    setIsDark(e)
  }

  const setAuto = (e: boolean) => {
    setIsAuto({ auto_theme: e })
  }

  const handleChange = (event: React.MouseEvent<HTMLElement>, newAlignment: ETheme) => {
    if (newAlignment === ETheme.DARK) {
      setDark(true)
      setAuto(false)
    }
    if (newAlignment === ETheme.LIGHT) {
      setDark(false)
      setAuto(false)
    }
    if (newAlignment === ETheme.AUTO) {
      setAuto(true)
    }
    setAlignment(newAlignment)
  }

  return (
    <ToggleButtonGroup
      color="primary"
      exclusive
      value={alignment}
      onChange={handleChange}
      aria-label="Platform"
      size={size || 'medium'}
    >
      <ToggleButton value={ETheme.LIGHT} disabled={alignment === ETheme.LIGHT || isLoading}>
        <LightModeIcon />
      </ToggleButton>
      <ToggleButton value={ETheme.AUTO} disabled={alignment === ETheme.AUTO || isLoading}>
        Auto
      </ToggleButton>
      <ToggleButton value={ETheme.DARK} disabled={alignment === ETheme.DARK || isLoading}>
        <DarkModeIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export { MultipleSwitch }
